var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bizAuth.editGroup.hasRight)?_c('div',{staticClass:"biz-edit-organization-group-page"},[_c('edit-organization-group-comp',{class:{'fixed': _vm.listIsFixed}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ba2bed3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bussiness/internalAuth/organizationGroup/editOrganizationGroup.vue
// module id = null
// module chunks = 